export const BUSINESS_PROFILE_PAGE_CONTENT_PATH = 'business-profile-page.index.'
export const MODULAR_SELLER_PAGE_CONTENT_PATH =
  'business-profile-page.seller-view-panel.index.'
